import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';

export const useAuth = () => {
  const { instance, accounts } = useMsal();
  const [isSessionValid, setIsSessionValid] = useState(false);

  const logout = async (logoutType: 'popup' | 'redirect' = 'redirect') => {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('TENANT_ID');
    localStorage.removeItem('FARM_ID');
    localStorage.removeItem('PDF_REQUEST');

    try {
      if (logoutType === 'popup') {
        await instance.logoutPopup({
          mainWindowRedirectUri: '/',
        });
      } else {
        await instance.logoutRedirect();
      }
    } catch (error) {
      window.location.href = '/';
    }
  };

  const clearLocalData = () => {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('TENANT_ID');
    localStorage.removeItem('FARM_ID');
    localStorage.removeItem('PDF_REQUEST');
  };

  const checkSessionValidity = () => {
    const hasAccounts = accounts && accounts.length > 0;
    const hasToken = localStorage.getItem('ACCESS_TOKEN');
    const isValid = hasAccounts && hasToken !== null;
    setIsSessionValid(isValid);
    return isValid;
  };
  useEffect(() => {
    checkSessionValidity();
  }, [accounts]);

  return {
    logout,
    clearLocalData,
    isSessionValid,
    checkSessionValidity,
  };
};
